import { useEffect, useState } from "react";
import { getClientAuthHeaders, getClientAuthToken } from "@/lib/apiAuth";
import { isGhlIntegrationActive } from "@/lib/ghlIntegrationActive";

export { isGhlIntegrationActive } from "@/lib/ghlIntegrationActive";

export function useGhlIntegrationActive() {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = getClientAuthToken();
    if (!token) {
      setIsActive(false);
      setIsLoading(false);
      return;
    }

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    let cancelled = false;

    (async () => {
      try {
        const response = await fetch(`${backendUrl}/api/integrations/ghl`, {
          method: "GET",
          headers: getClientAuthHeaders(),
        });
        if (!response.ok) {
          if (!cancelled) setIsActive(false);
          return;
        }
        const data = await response.json();
        if (!cancelled) setIsActive(isGhlIntegrationActive(data));
      } catch {
        if (!cancelled) setIsActive(false);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { isActive, isLoading };
}
